export interface ReferenceImageMasterUploadResponse {
  fileName: string
  url: string
}

export function ReferenceImageMasterUploadResponseFromJSON(
  json: any
): ReferenceImageMasterUploadResponse {
  return ReferenceImageMasterUploadResponseFromJSONTyped(json)
}

export function ReferenceImageMasterUploadResponseFromJSONTyped(
  json: any
): ReferenceImageMasterUploadResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fileName: json.file_name,
    url: json.url
  }
}
